import React from 'react';
import {
  type LayoutProps,
  LayoutProvider,
  useAppLayout,
} from '@core/contexts/LayoutContext';
import MobileLayout from './MobileLayout';
import WebOneLayout from './WebOneLayout';
import WebTwoLayout from './WebTwoLayout';

const Layout: React.FC<LayoutProps> = (props) => (
  <LayoutProvider {...props}>
    <LayoutSwitcher />
  </LayoutProvider>
);

function LayoutSwitcher() {
  const { isMobile, isWebOne } = useAppLayout();
  if (isMobile) return <MobileLayout />;
  if (isWebOne) return <WebOneLayout />;
  return <WebTwoLayout />;
}

export default Layout;
